import { render, staticRenderFns } from "./need-follow-or-add.vue?vue&type=template&id=2a3edb20&scoped=true&"
import script from "./need-follow-or-add.vue?vue&type=script&lang=js&"
export * from "./need-follow-or-add.vue?vue&type=script&lang=js&"
import style0 from "./need-follow-or-add.vue?vue&type=style&index=0&id=2a3edb20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3edb20",
  null
  
)

export default component.exports